import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  routes: [{
    path: '/shareWNQ',
    name: '分享',
    component: (resolve => require([`../pages/share/shareWnq.vue`], resolve))
  }]
})